<template>
    <v-card>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
                Campi macchine
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- Bottone di modifica -->
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="salvaConfigurazione()" small v-bind="attrs" v-on="on">
                        <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                </template>
                <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- Bottone per tornare indietro -->
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="clickBack" small v-bind="attrs" v-on="on">
                        <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                    </v-btn>
                </template>
                <span>Indietro</span>
            </v-tooltip>
        </v-toolbar>
        <v-row align="center" justify="center" class="mr-1 ml-1">
            <v-col cols="2">
                <v-autocomplete background-color="#ffffff" hide-details :items="lista_parametri" item-text="des"
                    item-value="cod" label="Parametro 1" v-model="parametro_1" @change="popolaListaPar1()">
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete background-color="#ffffff" hide-details :items="lista_parametro_1" item-text="des"
                    item-value="id_tabella" label="Valore parametro 1" v-model="val_parametro_1">
                </v-autocomplete>
            </v-col>
            <v-col cols="2">
                <v-autocomplete background-color="#ffffff" hide-details :items="lista_parametri" item-text="des"
                    item-value="cod" label="Parametro 2" v-model="parametro_2" @change="popolaListaPar2()">
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete background-color="#ffffff" hide-details :items="lista_parametro_2" item-text="des"
                    item-value="id_tabella" label="Valore parametro 2" v-model="val_parametro_2">
                </v-autocomplete>
            </v-col>
            <v-col cols="1">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="getConfigurazione()" v-bind="attrs" v-on="on">
                            <v-icon color="primary"> mdi-magnify </v-icon>
                        </v-btn>
                    </template>
                    <span>Cerca config. preesistente</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row align="center" justify="center" class="mr-1 ml-1">
            <v-col cols="8">
                <v-data-table dense :headers="headers" :items-per-page="-1" :items="elementi" :key="key_tabella">

                    <template v-slot:[`item.valore`]="{ item }">
                        <v-checkbox :true-value="1" dense hide-details :false-value="0" v-model="item.valore" />
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";


export default {
    name: "CampiMacchine",
    components: { SnackbarQV },
    props: {},
    data() {
        return {
            // Variabili d'appoggio
            key_tabella: false,
            parametro_1: null,
            parametro_2: null,
            val_parametro_1: null,
            val_parametro_2: null,
            elemento: {},
            elementi: [],
            // Modal

            overlay: false,
            overlay_cancellazione: false,

            // Array

            headers: [
                {
                    text: "Visualizza",
                    value: "valore",
                    sortable: false,
                    width: "50px",
                },
                {
                    text: "Nome",
                    value: "nome",
                    sortable: false,
                    width: "",
                },
                {
                    text: "Variabile",
                    value: "variabile",
                    sortable: false,
                    width: "",
                }

            ],
            tipi_macchina: [],
            sub_tipi_macchina: [],
            lista_parametri: [{ id_parametri: 1, des: "Tipo", cod: "id_tipo_get_macchina" },
            { id_parametri: 2, des: "Sub tipo", cod: "id_sub_tipo_macchina" }
            ],
            lista_parametro_1: [],
            lista_parametro_2: []
        };
    },
    computed: {},
    watch: {
        variabile: {
            immediate: true,
            handler() { },
        },
    },
    methods: {

        clickBack() {
            this.$emit("click_chiudi");
        },

        salvaConfigurazione() {

            const obj_tmp = {
                id_macchina_visibilita: this.elemento.id_macchina_visibilita,
                validita: 1,
                tipo_parametro_1: this.elemento.tipo_parametro_1,
                valore_parametro_1: this.elemento.valore_parametro_1,
                tipo_parametro_2: this.elemento.tipo_parametro_2,
                valore_parametro_2: this.elemento.valore_parametro_2,
            };

            this.elementi.forEach((el) => {
                obj_tmp[el.nome] = el.valore + ", " + el.variabile;
            });



            let request = {
                method: "PUT",
                controller: "magazzino",
                richiesta: {
                    action: "setvisibilitacampi",
                    token: localStorage.user_token,
                    visibilita_campi: [obj_tmp],
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.overlay = false;
                        this.getConfigurazione();
                        // Stampo una snackbar di conferma
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Campi salvati con successo!"
                        );

                        this.clickBack();
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nella comunicazione col server."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore critico nella comunicazione col server."
                    );
                });
        },

        getConfigurazione() {

            this.elementi = [];
            this.elemento = {};

            let request = {
                method: "POST",
                controller: "magazzino",
                richiesta: {
                    action: "getvisibilitacampidaconfig",
                    token: localStorage.user_token,
                    tipo_parametro_1: this.parametro_1,
                    valore_parametro_1: this.val_parametro_1,
                    tipo_parametro_2: this.parametro_2 ? this.parametro_2 : null,
                    valore_parametro_2: this.val_parametro_2 ? this.val_parametro_2 : null
                },
            };

            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.overlay = false;
                        if (res.data.result.length > 0) {
                            this.elemento = res.data.result[0];
                        } else {
                            this.elemento = {
                                id_macchina_visibilita: -1,
                                tipo_parametro_1: this.parametro_1,
                                valore_parametro_1: this.val_parametro_1,
                                tipo_parametro_2: this.parametro_2,
                                valore_parametro_2: this.val_parametro_2,
                                codice: "1, cod_macchina" ,
                                descrizione: "1, des_macchina",
                                //notes: "1, notes",
                                tipo: "1, id_tipo_get_macchina",
                                gruppo_energia: "1, id_gruppo_energia",
                                matricola: "1, matricola",
                                marca: "1, marca",
                                modello: "1, modello",
                                costo_orario: "1, costo_orario",
                                data_acquisto: "1, data_acquisto",
                                stato: "1, id_stato",
                                funzione: "1, id_funzione",
                                reparto: "1, id_reparto",
                                centrocosto: "1, id_centrocosto",
                                //inizio_garanzia: "1, inizio_garanzia",
                                //fine_garanzia: "1, fine_garanzia",
                                sub_tipo: "1, id_sub_tipo_macchina",
                                anagrafica: "1, id_anagrafica",
                                targa: "1, targa",
                                costo_km: "1, costo_km",
                                unita_di_misura_utilizzo: "1, id_udm_utilizzo",
                                fornitore: "1, id_anagrafica_fornitore",
                                proprietario: "1, id_anagrafica_proprieta",
                                costo_a_giornata: "1, costo_giornata" ,
                                utilizzo_max_giornaliero: "1, utilizzo_max_giorno",
                                consumo_orario_kwh: "1, consumo_orario_kwh",
                                numero_elementi: "1, numero_elementi",
                                processo_produzione: "1, id_processo_prod",
                                responsabile: "1, id_personale_responsabile",
                                //struttura_impianto: "1, tab_struttura"
                            }
                        }

                        console.log(this.elemento);
                        for (let field in this.elemento) {
                            if (field == "id_macchina_visibilita" ||
                                field == "tipo_parametro_1" ||
                                field == "tipo_parametro_2" ||
                                field == "valore_parametro_1" ||
                                field == "valore_parametro_2" ||
                                field == "validita" ||
                                field == "date_ins" ||
                                field == "date_mod" ||
                                field == "id_utente"
                            ) {
                                continue;
                            }
                            console.log(field);
                            this.elementi.push({ nome: field, 
                                                valore: Number(this.elemento[field].split(",")[0]), 
                                                variabile: this.elemento[field].split(",")[1] });
                        }

                        console.log(this.elementi);

                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nella comunicazione col server."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore critico nella comunicazione col server."
                    );
                });

        },

        popolaListaPar1() {

            switch (this.parametro_1) {
                case "id_tipo_get_macchina":
                    console.log("Entrato");
                    this.lista_parametro_1 = this.tipi_macchina;
                    break;
                case "id_sub_tipo_macchina":
                    this.lista_parametro_1 = this.sub_tipi_macchina;
            }

            console.log(this.tipi_macchina);
        },

        popolaListaPar2() {

            switch (this.parametro_2) {
                case "id_tipo_get_macchina":
                    this.lista_parametro_2 = this.tipi_macchina;
                    break;
                case "id_sub_tipo_macchina":
                    this.lista_parametro_2 = this.sub_tipi_macchina;
            }

        },


        getTabelle() {
            const request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.user_token,
                    tipo: "'TIPO_GET_MACCHINA', 'SUB_TIPO_MACCHINA'",
                },
            };

            this.overlay = true;

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        this.tipi_macchina = res.data.result.TIPO_GET_MACCHINA;
                        this.sub_tipi_macchina = res.data.result.SUB_TIPO_MACCHINA;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.overlay = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
                    );
                });
        },

    },

    created() { },
    mounted() {
        this.getTabelle();
    },
};
</script>
<style scoped></style>